import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import chevronUp from "../../assets/img/chevron_icon_up_orange.webp";
import chevronDown from "../../assets/img/chevron_icon_down_orange.webp";

function MobileDropDown({
  Header,
  Content,
  MobileMenuVisible,
  LinkClickFunction,
}) {
  const [showDropDown, setShowDropDown] = useState(false);

  const toggleDropDownMenu = () => {
    setShowDropDown(!showDropDown);
  };

  const DropDownItem = (item) => {
    return (
      <HashLink
        className="dropdown-menu-item"
        to={item.link}
        onClick={LinkClickFunction}
      >
        {item.title}
      </HashLink>
    );
  };

  const DropDownList = () => {
    if (showDropDown | (MobileMenuVisible && showDropDown)) {
      const dropdownList = [];
      Content.forEach((element) => {
        dropdownList.push(DropDownItem(element));
      });
      return <div className="dropdown-menu-items">{dropdownList}</div>;
    }
    return;
  };

  return (
    <div className="nav-link dropdown-menu">
      <div className="dropdown-menu-header" onClick={toggleDropDownMenu}>
        <span>{Header.title}</span>
        <img src={showDropDown ? chevronUp : chevronDown} alt="chevron"></img>
      </div>
      {DropDownList()}
    </div>
  );
}

export default MobileDropDown;
